export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY
export const API_URL= import.meta.env.VITE_API_URL
export const TINYMCE_API = import.meta.env.VITE_TINYMCE_API
export const MAINTENANCE_MODE = import.meta.env.VITE_MAINTENANCE_MODE
export const MSCLIENTID = import.meta.env.VITE_MSCLIENTID
export const IS_PRODUCTION = window.location.href.includes('bi.fedefarma.com')